import ResourceFactory from "./base/resource-factory";
import Audio from "./audio/audio";
import Camera from "./camera/camera";
import Boundary from "./boundary/boundary";
import Model from "./model/model";
import Scene from "./scene/scene";
import MediaScreen from "./mediaScreen/mediaScreen";
import Menu from "./menu/menu";
import Animation from "./animation/animation";
import Viewpoint from "./viewpoint/viewpoint";
import Style from "./style/style";
import _360ImageHotspot from "./360ImageHotspot/360ImageHotspot";
import _360VideoHotspot from "./360VideoHotspot/360VideoHotspot";
import InformationTag from "./informationTag/informationTag";
import ARMarker from "./armarker/armarker";
import HelperObject from "./helperObject/helperObject";
import { ResourceTypeEnum } from "./base/training-literals";

ResourceFactory.register('Audio', Audio);
ResourceFactory.register('Camera', Camera);
ResourceFactory.register('Boundary', Boundary);
ResourceFactory.register('Model', Model);
ResourceFactory.register('ARMarker', ARMarker)
ResourceFactory.register('MediaScreen', MediaScreen);
ResourceFactory.register('Menu', Menu);
ResourceFactory.register('Animation', Animation);
ResourceFactory.register('Scene', Scene);
ResourceFactory.register('Viewpoint', Viewpoint);
ResourceFactory.register('Style', Style);
ResourceFactory.register('360Image', _360ImageHotspot);
ResourceFactory.register('360Video', _360VideoHotspot);
ResourceFactory.register('InformationTag', InformationTag);
ResourceFactory.register(ResourceTypeEnum.HELPER_OBJECT, HelperObject);
